var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        { attrs: { placement: "left", trigger: "hover", width: "500" } },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.parsedMetadata, "show-header": false } },
            [
              _c("el-table-column", { attrs: { property: "key" } }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { property: "value" } }),
            ],
            1
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "el-icon-view",
            attrs: { slot: "reference" },
            slot: "reference",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }